import React from 'react'
import FeatureDetails from './FeatureDetails'
const DesignerDetails = () => {
  return <FeatureDetails benifitListCollection='nq-designer-plan-benefit-masters' isDesignerPlanBenefit={true}/>
}

export default DesignerDetails